import { Borders, Row, Workbook, Worksheet } from "exceljs";
import { ListDocumenType } from "../../types";

type ExportExcelDocumentType = {
  data: ListDocumenType[];
};

export const exportExcelDocumentType = async ({
  data,
}: ExportExcelDocumentType) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet("Sheet 1");
  const columns = ["NO", "CODE", "DOCUMENT TYPE", "DESCRIPTION"];
  worksheet.views = [{ showGridLines: false }];

  worksheet.mergeCells(2, 1, 1, columns.length);

  // Title
  makeTitle(worksheet);

  // Header
  const headers = worksheet.addRow(columns);
  headers.font = { bold: true };
  headers.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF8C308" },
    };
    cell.border = {
      top: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } },
    };
  });

  makeRows(data, worksheet);

  // create xlsx
  await workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "document-type.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  });
};

function makeTitle(worksheet: Worksheet) {
  const titleCell = worksheet.getCell(1, 2);
  titleCell.value = "DOCUMENT TYPE";
  titleCell.alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true,
  };
  titleCell.font = { bold: true, size: 15 };

  worksheet.getColumn(2).width = 20;
}

function makeRows(data: ExportExcelDocumentType["data"], worksheet: Worksheet) {
  let itemRow: Row;

  const cellBorder: Partial<Borders> = {
    top: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } },
    bottom: { style: "thin", color: { argb: "000000" } },
    right: { style: "thin", color: { argb: "000000" } },
  };

  data.forEach((item, index) => {
    itemRow = worksheet.addRow([
      index + 1,
      item.mr_document_code,
      item.mr_document_name,
      item.description,
    ]);

    itemRow.eachCell((cell) => {
      cell.border = cellBorder;
    });
  });
}
